module.exports = __webpack_public_path__ + "img/pax.3ea69b12.svg";